export class RotaErrors {
  errors: StoreError[];
  warnings: StoreWarning[];

  constructor(errors: StoreError[], warnings: StoreWarning[]) {
    this.errors = errors;
    this.warnings = warnings;
  }
}

export class StoreError {
  type: string;
  reason: string;

  constructor(type: string, reason: string) {
    this.type = type;
    this.reason = reason;
  }
}

export class StoreWarning {
  type: string;
  reason: string;

  constructor(type: string, reason: string) {
    this.type = type;
    this.reason = reason;
  }
}
